<script setup>
import { storeToRefs } from 'pinia'
import { useUsersStore } from "@/stores"
import PreferredTabsContent from "@core/components/PreferredTabsContent.vue"

const usersStore = useUsersStore()
const { isShowingPreferredTabsDialog } = storeToRefs(usersStore)

const onClose = () => {
  isShowingPreferredTabsDialog.value = false
}
</script>

<template>
  <VDialog
    max-width="500"
    :model-value="isShowingPreferredTabsDialog"
    scrollable
    @update:model-value="val => { if (!val) onClose() }"
  >
    <VCard class="preferred-tabs-dialog-card">
      <VCardText class="pa-0">
        <PreferredTabsContent />
      </VCardText>
    </VCard>
    <VBtn
      icon="$close"
      size="large"
      variant="text"
      color="secondary"
      class="dialog-close-btn"
      @click="onClose"
    >
      <VIcon>mdi-close</VIcon>
    </VBtn>
  </VDialog>
</template>

<style scoped>
.dialog-close-btn {
  position: fixed;
  right: 6px;
  top: 6px;
}

.preferred-tabs-dialog-card {
  max-height: 80vh;
  overflow-y: auto;
}
</style>
